import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

//styled
export default function RefundModal({
  cancelModal,
  selectedPayment,
  fetchData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();



  function convertToMoney(amount) {
    // Convert integer to float with two decimal places
    const formattedAmount = (amount / 100).toFixed(2);

    // Return as a formatted string with the £ symbol
    return `£${formattedAmount}`;
  }

  const handleRefund = async () => {
    setIsLoading(true);
    try {
      const refundResponse = await axios.post(
        `${ApiConnectionString}/api/refund/${selectedPayment.id}`,
        null,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      if (refundResponse.status === 200) {
        setComplete(true);
      }
    } catch (error) {
      console.error("Refund failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (!selectedPayment.refunded) {
      if (!complete) {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
            <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Refund Request</p>
        </div>

              <div className="d-flex">
          <span className="red-text">Club</span>
          <p className="mx-3">{selectedPayment.clubName}</p>
        </div>
        <div className="d-flex">
          <span className="red-text">Amount</span>
          <p className="mx-3">
            {convertToMoney(selectedPayment.amount)}
          </p>
        </div>
        <p>Are you sure that you wish to request this refund?</p>
              <div className="send-modal-footer">
                <button className="saveChanges-button mx-3" onClick={handleRefund}>
              Confirm  
                </button>
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
            <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Refund Accepted</p>
        </div>
        <p>
  Your refund has been accepted. Please note that Stripe, our payment processor, typically processes refunds within 5-10 business days. The exact timing may vary depending on the payment method used. Refunds to credit or debit cards usually take 5-10 business days, while bank transfers and other payment methods may also take a similar amount of time. The funds may take additional time to appear in your account, depending on your bank or payment provider.
</p>

              <div className="send-modal-footer">
                <button
                  className="pointer cancelButton fw-bold mx-2 px-3"
                  onClick={() => {
                    fetchData();
                    cancelModal();
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        );
      }
    }
  }
}
